/* eslint-disable*/
import React, { useState, useEffect, useMemo } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from "axios";
import { API_URL } from "../../config";
import { showToast } from "../../components/toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import LoadingSpinner from "../../components/LoadingSpinner";

const SendEmail = () => {
  const [formData, setFormData] = useState({
    sendto: "",
    subject: "",
    message: "",
    imageUrl: null,
  });
  const [sentEmails, setSentEmails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 100,
    total: 0,
    totalPages: 1,
  });

  // Quill modules
  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: "1" }, { header: "2" }, { font: [] }],
          [{ size: [] }],
          ["bold", "italic", "underline", "strike", "blockquote"],
          [
            { list: "ordered" },
            { list: "bullet" },
            { indent: "-1" },
            { indent: "+1" },
          ],
          ["link", "image"],
          ["clean"],
        ],
      },
      clipboard: {
        matchVisual: false,
      },
    }),
    []
  );

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
  ];

  // Fetch sent emails
  useEffect(() => {
    const fetchSentEmails = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const response = await axios.get(
          `${API_URL}socialsharing/getSendMail`,
          {
            params: {
              page: pagination.page,
              limit: pagination.limit,
            },
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        setSentEmails(response.data.data);
        setPagination((prev) => ({
          ...prev,
          total: response.data.total,
          totalPages: response.data.totalPages,
        }));
        setLoading(false);
      } catch (err) {
        console.error("Error fetching sent emails:", err);
        showToast.error("Failed to load sent emails");
        setLoading(false);
      }
    };

    fetchSentEmails();
  }, [pagination.page, pagination.limit]);

  useEffect(() => {
    const handleClearEvent = () => {
      setFormData({
        sendto: "",
        subject: "",
        message: "",
        imageUrl: null,
      });
    };

    window.addEventListener('clearEmailFiltersEvent', handleClearEvent);
    return () => {
      window.removeEventListener('clearEmailFiltersEvent', handleClearEvent);
    };
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    setFormData({
      ...formData,
      imageUrl: e.target.files[0],
    });
  };

  const handleEditorChange = (content) => {
    setFormData({
      ...formData,
      message: content,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const token = localStorage.getItem("authToken");
      const formDataToSend = new FormData();

      formDataToSend.append("sendto", formData.sendto);
      formDataToSend.append("subject", formData.subject);
      formDataToSend.append("message", formData.message);
      if (formData.imageUrl) {
        formDataToSend.append("imageUrl", formData.imageUrl);
      }

      await axios.post(`${API_URL}socialsharing/saveMail`, formDataToSend, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      // Reset form
      setFormData({
        sendto: "",
        subject: "",
        message: "",
        imageUrl: null,
      });
      showToast.success("Email sent successfully!");

      // Refresh list
      const refreshResponse = await axios.get(
        `${API_URL}socialsharing/getSendMail`,
        {
          params: {
            page: pagination.page,
            limit: pagination.limit,
          },
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setSentEmails(refreshResponse.data.data);
      setPagination((prev) => ({
        ...prev,
        total: refreshResponse.data.total,
        totalPages: refreshResponse.data.totalPages,
      }));
    } catch (err) {
      console.error("Error sending email:", err);
      showToast.error(err.response?.data?.message || "Failed to send email");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= pagination.totalPages) {
      setPagination((prev) => ({
        ...prev,
        page: newPage,
      }));
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  // Calculate start and end numbers
  const start = (pagination.page - 1) * pagination.limit + 1;
  const end = Math.min(pagination.page * pagination.limit, pagination.total);

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      <div id="content" className="">
        <div className="panel panel-default with-rounded-corner with-shadow">
          <form
            onSubmit={handleSubmit}
            className="stdform"
            encType="multipart/form-data"
          >
            <input type="hidden" name="subscriberid" value="" />
            <div className="panel-heading">
              <span className="panel-title">Manage Sent Email</span>
            </div>
            <div className="panel-body">
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label className="control-label">Email Id</label>
                    <input
                      type="email"
                      name="sendto"
                      className="form-control"
                      placeholder="Enter EmailId"
                      value={formData.sendto}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>

                <div className="col-md-8">
                  <div className="form-group">
                    <label className="control-label">Subject</label>
                    <input
                      type="text"
                      name="subject"
                      className="form-control"
                      placeholder="Enter Subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="form-group">
                    <label className="control-label">Message</label>
                    <ReactQuill
                      theme="snow"
                      value={formData.message}
                      onChange={handleEditorChange}
                      modules={modules}
                      formats={formats}
                      style={{ height: "300px", marginBottom: "50px" }}
                    />
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="form-group">
                    <label className="control-label">Upload File</label>
                    <input
                      type="file"
                      name="imageUrl"
                      className="form-control"
                      onChange={handleFileChange}
                    />
                  </div>
                </div>

                <div className="clearfix"></div>
                <div className="col-md-3">
                  <div style={{ float: "left", marginTop: "20px" }}>
                    <button
                      type="submit"
                      name="submit"
                      className="btn btn-primary"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div className="panel panel-default with-rounded-corner with-shadow p-10">
          <div className="table-responsive">
            {pagination.total > pagination.limit && (
              <div className="d-flex  align-items-center mt-2 float-end mb-2">
                <span style={{ fontSize: "0.85rem" }}>
                  {start} to {end} of {pagination.total}
                </span>
                <div>
                  <button
                    className="btn btn-default btn-sm ms-2"
                    title="Previous"
                    onClick={() => handlePageChange(pagination.page - 1)}
                    disabled={pagination.page === 1}
                  >
                    <FontAwesomeIcon icon={faChevronLeft} />
                  </button>
                  &nbsp;
                  <button
                    className="btn btn-default btn-sm"
                    title="Next"
                    onClick={() => handlePageChange(pagination.page + 1)}
                    disabled={pagination.page >= pagination.totalPages}
                  >
                    <FontAwesomeIcon icon={faChevronRight} />
                  </button>
                </div>
              </div>
            )}
            <table className="table table-condensed table-bordered bg-white">
              <thead>
                <tr>
                  <th style={{ textAlign: "center" }}>#</th>
                  <th>Sent Email</th>
                  <th>Message</th>
                  <th>Attachment</th>
                </tr>
              </thead>
              <tbody>
                {sentEmails.length > 0 ? (
                  sentEmails.map((email, index) => (
                    <tr key={email.id}>
                      <td
                        style={{ textAlign: "center", verticalAlign: "middle" }}
                      >
                        {(pagination.page - 1) * pagination.limit + index + 1}
                      </td>
                      <td>{email.sendto}</td>
                      <td>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: email.message || "No message content",
                          }}
                        />
                      </td>
                      <td>
                        {email.imageUrl ? (
                          <a
                            href={email.imageUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View Attachment
                          </a>
                        ) : (
                          <span>No attachment</span>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="6"
                      style={{ textAlign: "center", padding: "10px" }}
                    >
                      No emails sent yet
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <input type="hidden" name="delid" id="delid" value="0" />

        {/* Scroll to top */}
        <a href="#" data-click="scroll-top" className="btn-scroll-top fade">
          <i className="ti-arrow-up"></i>
        </a>
      </div>
    </div>
  );
};

export default SendEmail;
